export default "__VITE_ASSET__4e897be5__"